import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import Cookies from "universal-cookie";
import { ADMIN_API, USER_API } from "../common/common";
import { getImageUrl, setAuthCookie } from "../common/Funcation";
import {
  styleObjectBlackButton,
  styleObjectGetBG,
  styleObjectGetBGasColor,
  styleObjectGetColor,
} from "../common/StyleSeter";
import { getApiLink, notifyError, notifyMessage, postApi } from "../service";
import instagram from "./../assets/icons/instagram.svg";
import mail from "./../assets/icons/mail.svg";
import skype from "./../assets/icons/skype.svg";
import telegram from "./../assets/icons/telegram.svg";
import whatsapp from "./../assets/icons/whatsapp.svg";
const cookies = new Cookies();
const ChangePassword = () => {
  const [, updateState] = React.useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const forceUpdate = React.useCallback(() => updateState({}), []);
  const [formData, setFormData] = useState({
    newPassword: "",
    conformPassword: "",
    currentPassword: "",
  });
  const SocialIcon = [
    { iconStatus: true, link: "", image: mail, name: "mail" },
    { iconStatus: true, link: "", image: whatsapp, name: "whatsapp" },
    { iconStatus: true, link: "", image: telegram, name: "telegram" },
    { iconStatus: true, link: "", image: skype, name: "skype" },
    { iconStatus: true, link: "", image: instagram, name: "instagram" },
  ];
  const SocialContact = ["+918888899999", "+918888897779", "+91888884399"];
  const [confirmationCode] = useState(Math.floor(1000 + Math.random() * 9000));
  const [isValidationWrong, setIsValidationWrong] = useState(false);
  const [isError, setIsError] = useState({ flag: false, msg: "" });
  const DD = useSelector((e: any) => e.domainDetails);
  const [showPass, setShowPass] = useState(false);

  const [isHover, setIsHover] = useState(false);
  const handleMouseEnter = () => {
    setIsHover(true);
  };
  const handleMouseLeave = () => {
    setIsHover(false);
  };
  const handelInputChange = (e: any) => {
    const { name, value } = e.target;
    setIsValidationWrong(false);
    setFormData({ ...formData, [name]: value });
  };
  const handelSubmit = async (e: any) => {
    e.preventDefault();
    if (
      Validator.current.allValid() &&
      formData.newPassword === formData.conformPassword
    ) {
      setIsValidationWrong(false);
      // const ipDetails = await getApiLink({
      //   api: "https://ipapi.co/json/?key=wfzfdfQ4cUsaTVURUkj2oF6L51Y4jNE0IM2yE0V2xMyMkxjTsr",
      // });
      // console.log("call ip:  ipDetails :", ipDetails);

      let data = {
        api: USER_API.CHANGE_PASSWORD,
        value: {
          currentPassword: formData.currentPassword,
          newPassword: formData.newPassword,
          conformPassword: formData.conformPassword,
          // city: ipDetails?.data?.city,
          // state: ipDetails?.data?.region,
          // country: ipDetails?.data?.country_name,
          // ISP: ipDetails?.data?.org
        },
        token: cookies.get("skyTokenFront"),
      };
      await postApi(data)
        .then(function (response) {
          setAuthCookie(response.data.data.token);

          notifyMessage("change password successfully");
          setTimeout(() => {
            window.location.href = "/";
          }, 500);
          // navigate('/')
        })
        .catch((err) => {
          notifyError(err.response.data.message);
          setIsError({
            flag: true,
            msg: err.response.data.message,
          });

          if (err.response.data.statusCode === 401) {
            // Logout()
            // navigate('/login')
          }
        });
      // if (loginData) {

      //     // dispatch({ type: 'HEADER_DETAILS', payload: HeaderData })
      //     // cookies.set('skyTokenFront', loginData.data.data.token, { domain: process.env.REACT_APP_COOKIE_DOMAIN, path: '/' })
      //     // dispatch({ type: 'AUTHENTICATION', payload: { isLogin: true, token: loginData.data.data.token } })
      // }
    } else {
      if (formData.newPassword !== formData.conformPassword) {
        notifyError("password not match");
      }
      Validator.current.showMessages();
      forceUpdate();
    }
  };
  const Validator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: this,
    })
  );

  return (
    // <div className="login_main changepass">
    //   <div
    //     className="login_main_popup "
    //     // style={styleObjectGetBG(DD?.colorSchema)}
    //   >
    //     <div className="login_main_popup_wrp">
    //       <div
    //         className="login_main_popup_left "
    //         // style={styleObjectGetBG(DD?.colorSchema)}
    //       >
    //         <ul>
    //           <li>
    //             Password must have 8 to 15 alphanumeric without white space
    //           </li>
    //           <li>Password cannot be the same as username/nickname</li>
    //           <li>
    //             Must contain at least 1 capital letter, 1 small letter and 1
    //             number
    //           </li>
    //           <li>
    //             Password must not contain any special characters (!,@,#,etc..)
    //           </li>
    //         </ul>
    //       </div>
    //       <div className="login_form_main">
    //         <h3 className="form_title"> Change Password </h3>
    //         <form className="login_form" onSubmit={(e) => handelSubmit(e)}>
    //           <InputGroup
    //             name="newPassword"
    //             value={formData.newPassword}
    //             type="password"
    //             onChange={handelInputChange}
    //             placeholder="New Password"
    //             errorValidation={Validator.current.message(
    //               "newPassword",
    //               formData.newPassword,
    //               "required"
    //             )}
    //           />
    //           <InputGroup
    //             name="conformPassword"
    //             value={formData.conformPassword}
    //             type="password"
    //             onChange={handelInputChange}
    //             placeholder="New Password Confirm"
    //             errorValidation={Validator.current.message(
    //               "conformPassword",
    //               formData.conformPassword,
    //               "required"
    //             )}
    //           />
    //           <InputGroup
    //             name="currentPassword"
    //             value={formData.currentPassword}
    //             type="password"
    //             onChange={handelInputChange}
    //             placeholder="Old Password"
    //             errorValidation={Validator.current.message(
    //               "currentPassword",
    //               formData.currentPassword,
    //               "required"
    //             )}
    //           />

    //           {isValidationWrong ? (
    //             <span className="error" style={{ color: "red" }}>
    //               invalid verification code
    //             </span>
    //           ) : (
    //             ""
    //           )}
    //           <button
    //             type="submit"
    //             style={styleObjectGetBGasColor(DD?.colorSchema)}
    //             className="w-100 btn_black hover-border"
    //             onSubmit={(e) => handelSubmit(e)}
    //           >
    //             Change
    //           </button>
    //         </form>
    //       </div>
    //     </div>
    //     <div className="maintain-footer">
    //       <img src={getImageUrl(DD?.logo)} alt="logo" />
    //     </div>
    //   </div>

    //   {/* <div className='login_footer'>
    //             <div className='login_footer_social'>
    //                 {SocialIcon.map((item) => <div className="social_icon">
    //                     <img src={item.image} alt={item.name} />
    //                 </div>)}
    //             </div>
    //             <div className="login_footer_contact">
    //                 {SocialContact.map((item) => (
    //                     <span>{item}</span>
    //                 ))}
    //             </div>
    //         </div> */}
    // </div>

    <div className="inner-container">
      <style>
        {`
        .login-panel .form-floating .form-control {
        padding: 0 0.5rem !important;
        }
        .login-panel .form-floating label {
        margin-left: 1.2rem !important;
        }
        .login_btn{
        line-height: 1.2;
        padding: 0.75rem;
        }
        `}
      </style>
      <div
        className={` login_main mobile_screen`}
        // style={styleObjectGetBGIMageLoginImage(DD?.mobileLoginImage) || {}}
        style={{ backgroundImage: `url(${getImageUrl(DD?.mobileLoginImage)})`, backgroundSize: "contain", backgroundPosition: "top", backgroundRepeat: "no-repeat" }}
      >
        <a id="close" className="close" href="/">
          <svg
            stroke="currentColor"
            fill="#000"
            strokeWidth="0"
            viewBox="0 0 512 512"
            className="fs-1 p-1 cursor-pointer"
            height="30"
            width="30"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M217.9 256L345 129c9.4-9.4 9.4-24.6 0-33.9-9.4-9.4-24.6-9.3-34 0L167 239c-9.1 9.1-9.3 23.7-.7 33.1L310.9 417c4.7 4.7 10.9 7 17 7s12.3-2.3 17-7c9.4-9.4 9.4-24.6 0-33.9L217.9 256z"></path>
          </svg>
        </a>
        <div className={`login-screen login_main_mobile`}>
          {/* <div className="login-logo">
                  <img src={getImageUrl(DD?.mobileLoginImage)} alt="" />
                </div> */}
          {/* <div
                  className="login_popup_image"
                  style={styleObjectGetBGIMageLoginImage(DD?.loginImage) || {}}
                ></div> */}
          <div className="login_form_main login-panel">
            <h3
              style={styleObjectGetColor(DD?.colorSchema, false, true)}
              className="form_title"
            >
              {" "}
              Change Password{" "}
            </h3>

            <form
              className={`bg-white ${DD?.colorSchema}`}
              onSubmit={(e) => handelSubmit(e)}
            >
              <div className="">
                <div className="form-floating">
                  <input
                    autoComplete="off"
                    placeholder="New Password"
                    maxLength={15}
                    name="newPassword"
                    type={showPass ? "text" : "password"}
                    id="floatingPassword"
                    className="form-control"
                    value={formData.newPassword}
                    onChange={handelInputChange}
                    // style={styleObjectGetBorderColor(DD?.colorSchema)}
                    style={isError.flag ? { borderColor: "red", margin: "0.75rem 0", height: "41px" } : { margin: "0.75rem 0", height: "41px" }}

                  />
                  <button
                    onClick={() => setShowPass(!showPass)}
                    type="button"
                    className="position-absolute eye-img translate-middle-y top-50 end-0 me-2 bg-transparent border-0 text-dark p-0  btn btn-primary"
                  >
                    {!showPass ? (
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth="0"
                        viewBox="0 0 640 512"
                        className="opacity-100 fs-5"
                        height="17"
                        width="17"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"></path>
                      </svg>
                    ) : (
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth="0"
                        viewBox="0 0 576 512"
                        className="opacity-100 fs-5"
                        height="17"
                        width="17"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"></path>
                      </svg>
                    )}
                  </button>
                  <label htmlFor="floatingPassword">New Password</label>
                </div>
                {Validator.current.message(
                  "newPassword",
                  formData.newPassword,
                  "required"
                ) ? (
                  <span className="error" style={{ color: "red" }}>
                    {Validator.current.message(
                      "newPassword",
                      formData.newPassword,
                      "required"
                    )}
                  </span>
                ) : (
                  ""
                )}
              </div>
              <div>
                <div className="form-floating">
                  <input
                    autoComplete="off"
                    placeholder="New Password Confirm"
                    maxLength={15}
                    name="conformPassword"
                    type={showPass ? "text" : "password"}
                    id="floatingPassword"
                    className="form-control"
                    value={formData.conformPassword}
                    onChange={handelInputChange}
                    // style={styleObjectGetBorderColor(DD?.colorSchema)}
                    style={isError.flag ? { borderColor: "red", margin: "0.75rem 0" } : { margin: "0.75rem 0" }}
                  />

                  <button
                    onClick={() => setShowPass(!showPass)}
                    type="button"
                    className="position-absolute eye-img translate-middle-y top-50 end-0 me-2 bg-transparent border-0 text-dark p-0  btn btn-primary"
                  >
                    {!showPass ? (
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth="0"
                        viewBox="0 0 640 512"
                        className="opacity-100 fs-5"
                        height="17"
                        width="17"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"></path>
                      </svg>
                    ) : (
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth="0"
                        viewBox="0 0 576 512"
                        className="opacity-100 fs-5"
                        height="17"
                        width="17"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"></path>
                      </svg>
                    )}
                  </button>
                  <label htmlFor="floatingPassword">New Password Confirm</label>
                </div>
                {Validator.current.message(
                  "conformPassword",
                  formData.conformPassword,
                  "required"
                ) ? (
                  <span className="error" style={{ color: "red" }}>
                    {Validator.current.message(
                      "conformPassword",
                      formData.conformPassword,
                      "required"
                    )}
                  </span>
                ) : (
                  ""
                )}
              </div>
              <div>
                <div className="form-floating">
                  <input
                    autoComplete="off"
                    placeholder="Your Password"
                    maxLength={15}
                    name="currentPassword"
                    type={showPass ? "text" : "password"}
                    id="floatingPassword"
                    className="form-control"
                    value={formData.currentPassword}
                    onChange={handelInputChange}
                    // style={styleObjectGetBorderColor(DD?.colorSchema)}
                    style={isError.flag ? { borderColor: "red", margin: "0.75rem 0" } : { margin: "0.75rem 0" }}
                  />

                  <button
                    onClick={() => setShowPass(!showPass)}
                    type="button"
                    className="position-absolute eye-img translate-middle-y top-50 end-0 me-2 bg-transparent border-0 text-dark p-0  btn btn-primary"
                  >
                    {!showPass ? (
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth="0"
                        viewBox="0 0 640 512"
                        className="opacity-100 fs-5"
                        height="17"
                        width="17"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"></path>
                      </svg>
                    ) : (
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        strokeWidth="0"
                        viewBox="0 0 576 512"
                        className="opacity-100 fs-5"
                        height="17"
                        width="17"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"></path>
                      </svg>
                    )}
                  </button>
                  <label htmlFor="floatingPassword">Your Password</label>
                </div>
                {Validator.current.message(
                  "currentPassword",
                  formData.currentPassword,
                  "required"
                ) ? (
                  <span className="error" style={{ color: "red" }}>
                    {Validator.current.message(
                      "currentPassword",
                      formData.currentPassword,
                      "required"
                    )}
                  </span>
                ) : (
                  ""
                )}
              </div>
              {/* {isCaptcha === 'true' &&
                      <div className="mb-4">
                        <div className="form-floating">
                          <input
                            autoComplete="off"
                            maxLength={4}
                            name="validationCode"
                            placeholder="Validation Code"
                            type="number"
                            id="floatingValid"
                            className="form-control"
                            value={formData.validationCode}
                            onChange={handelInputChange}
                          // style={styleObjectGetBorderColor(DD?.colorSchema)}
                          />
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            strokeWidth="0"
                            viewBox="0 0 512 512"
                            className="position-absolute translate-middle-y top-50"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM256.1 446.3l-.1-381 175.9 73.3c-3.3 151.4-82.1 261.1-175.8 307.7z"></path>
                          </svg>
                          <div
                            style={styleObjectGetColor(DD?.colorSchema, false, true)}
                            className="validation_code"
                          >
                            <h3>{confirmationCode}</h3>
                          </div>
                          <label htmlFor="floatingValid">ValidationCode</label>
                        </div>
                        {Validator.current.message(
                          "validationCode",
                          formData.validationCode,
                          "required"
                        ) ? (
                          <span className="error" style={{ color: "red" }}>
                            {Validator.current.message(
                              "validationCode",
                              formData.validationCode,
                              "required"
                            )}
                          </span>
                        ) : (
                          ""
                        )}
                      </div>
                    } */}
              {/* <div className="form-check">
                      <input
                        type="checkbox"
                        id="custom-switch"
                        className="form-check-input"
                      />
                      <label
                        title=""
                        htmlFor="custom-switch"
                        className="form-check-label"
                      >
                        Remember me
                      </label>
                    </div> */}
              {isError.flag && (
                <div
                  style={{
                    paddingTop: "10px",
                    color: "red",
                    fontSize: "16px",
                  }}
                >
                  <span>{isError.msg}</span>
                </div>
              )}
              <div className="text-center mt-1" style={{ marginBottom: "1.5rem" }}>
                {/* <button type="submit" className="theme-btn ms-auto px-5 btn btn-primary">Login</button> */}
                <button
                  type="submit"
                  className="login_btn"
                  style={{
                    ...styleObjectGetBGasColor(DD?.colorSchema),
                    marginTop: "0px", fontSize: "14.57px"
                  }}
                  onSubmit={(e) => handelSubmit(e)}
                >
                  Change
                </button>
              </div>
            </form>
            <div className="login_main_popup_wrp">
              <div
                className="login_main_popup_left "
                style={{ fontSize: "12.48px", marginLeft: "1rem" }}
              >
                <ul style={{ listStyleType: "disc", listStylePosition: "outside" }}>
                  <li style={{ listStyleType: "disc", listStylePosition: "outside" }}>
                    Password must have 8 to 15 alphanumeric without white space
                  </li>
                  <li style={{ listStyleType: "disc", listStylePosition: "outside" }}>Password cannot be the same as username/nickname</li>
                  <li style={{ listStyleType: "disc", listStylePosition: "outside" }}>
                    Must contain at least 1 capital letter, 1 small letter and 1
                    number
                  </li>
                  <li style={{ listStyleType: "disc", listStylePosition: "outside" }}>
                    Password must not contain any special characters (!,@,#,etc..)
                  </li>
                </ul>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ChangePassword;

export const InputGroup = (props: any) => {
  const { type, placeholder, name, value, onChange, errorValidation } = props;
  return (
    <div className="input_group">
      <input
        type={type}
        name={name}
        value={value}
        onChange={(e) => onChange(e)}
        placeholder={placeholder}
      />
      {errorValidation ? (
        <span className="error" style={{ color: "red" }}>
          {errorValidation}
        </span>
      ) : (
        ""
      )}
    </div>
  );
};
